<app-page-shell variant="default" [embedded]="isModal()">
<!-- Add User Section  Start -->
  <app-sb-input-form
    [mode]="packageId() ? 'edit' : 'add'"
    [title]="(packageId() ? 'Edit' : 'Add') + ' Package'"
    submitLabel="Save"
    [stickyFooter]="!isModal()"
    [embedded]="isModal()"
    (submitted)="savePackage()"
    (cancelled)="cancelClick()">
        <div class="form-wraper" [formGroup]="addPackageForm">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-ms-12">
                <div class="floating-label">
                  <input [class.is-invalid]="submitted() && f.name.errors"
                         formControlName="name" id="name" placeholder=" "
                         required="required" class="floating-input" min="0"
                         type="text"/>
                  <label for="name">Name <span class="red">*</span>
                  </label>
                  @if (submitted() && f.name.errors) {
                  <div class="bar error-brd">
                    @if (f.name.errors.required) {
                    <div class="invalid-text">Name is required</div>
                    }
                  </div>
                  }

                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-ms-12">
                <div class="floating-label">
                  <input [class.is-invalid]="submitted()"
                         formControlName="project_count_limit" id="project_count_limit" placeholder=" "
                         required="required" class="floating-input" min="0"
                         type="number"/>
                  <label for="project_count_limit">Project Limit
                  </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-ms-12">
                <div class="floating-label">
                  <input [class.is-invalid]="submitted()"
                         formControlName="project_campaign_count_limit" id="project_campaign_count_limit"
                         placeholder=" "
                         required="required" class="floating-input" min="0"
                         type="number"/>
                  <label for="project_campaign_count_limit">Project Campaign Limit
                  </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-ms-12">
                <div class="floating-label">
                  <input [class.is-invalid]="submitted()"
                         formControlName="project_influencer_count_limit" id="project_influencer_count_limit"
                         placeholder=" "
                         required="required" class="floating-input" min="0"
                         type="number"/>
                  <label for="project_influencer_count_limit">Project Influencer Limit
                  </label>
                </div>
              </div>
            </div>
        </div>
  </app-sb-input-form>
</app-page-shell>
